import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',[_c(VBreadcrumbs,{attrs:{"divider":">","items":_vm.breadcrumbs,"exact":""}}),_c('invoice-details',{attrs:{"invoice":_vm.invoice}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }